export default {
  title: 'Product Category',
  addPrimary: 'Add Primary Category',
  addSecondary: 'Add Secondary Category',
  collapseAll: 'Collapse All',
  language: 'Language',
  categoryName: 'Category Name',
  categoryNamePlaceholder: 'Please enter category name',
  searchPlaceholder: 'Please enter keyword',
  giftCount: 'Gift Count',
  modify: 'Edit',
  multilingual: 'Multilingual',
  addPrimaryTitle: 'Add Primary Category',
  addSecondaryTitle: 'Add Secondary Category',
  editTitle: 'Edit Category',
  multiLangTitle: 'Multilingual',
  deleteIrreversible: 'This action cannot be undone. Are you sure to delete?',
  langRequired: 'Please select language',
  nameRequired: 'Please enter category name',
  firstAddTip:
    'The default system language is used on first add. Clicking [Multilingual] uses the language selected in list filter.',
};
